import { useEffect } from "react";

const KommoLiveChat = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    script.innerHTML = `
      (function (a, m, o, c, r, m) {
        a[m] = {
          id: "1063431",
          hash: "12920dcfe094ea2dbd4ae6ae2089a6a14ecbe2bd7553278cb730a32be4fb1cd2",
          locale: "en",
          setMeta: function (p) {
            this.params = (this.params || []).concat([p]);
          },
        };
        a[o] =
          a[o] ||
          function () {
            (a[o].q = a[o].q || []).push(arguments);
          };
        var d = a.document,
          s = d.createElement("script");
        s.async = true;
        s.id = m + "_script";
        s.src = "https://gso.kommo.com/js/button.js";
        d.head && d.head.appendChild(s);
      })(window, 0, "crmPlugin", 0, 0, "crm_plugin");
    `;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default KommoLiveChat;